export enum DocumentEditorTwoStepContentActionType {
  InsertBefore = 'insertBefore',
  InsertAfter = 'insertAfter',
  InsertInside = 'insertInside',
  InsertStart = 'insertStart',
  InsertEnd = 'insertEnd',
  Update = 'update',
}
